import TableSkeleton from '../../../components/loaders/TableSkeleton';
import ListHeader from '../../../components/ListHeader';
import { useTranslation } from 'react-i18next';
import useModuleTableHelpers from '../../../hooks/useModuleTableHelpers';
import { useNavigate, useParams } from 'react-router-dom';
import VariantsTableContainer from '../../../modules/variants/components/VariantsTableContainer';
import Button from '../../../components/buttons/Button';
import { hasPermission } from '../../../utils/HelperFunctions';

const VariantsList = () => {
  const { t } = useTranslation();
  const navigate = useNavigate()
  const {id, modelId} = useParams()

  const { apiData, apiDataLoading, searchEle, paginationEle } = useModuleTableHelpers({
    route: `admin/models/${modelId}/variants`,
    withBreadcrumb: true,
    withSearch: true,
    breadcrumbTitle: t('variants'),
    withPagination: true
  });

  const tableHeaders = [
    { label: t('name'), customClass: 'flex-grow-2' },
    { label: t('code') },
    // { label: t('transmission') },
    { label: t('model_year') },
    { label: t('hidden') },
    hasPermission(['variants.edit']) && { label: t('actions'), customClass: 'actions_col' }
  ].filter(Boolean);

  if (apiDataLoading && !apiData) return <TableSkeleton columns={6} withoutButton />;

  return (
    <div className="vehicles-page-container">
      <ListHeader customClass='table_filters'>
        <div className="filter_container">{searchEle}</div>
        {hasPermission(["variants.edit"]) && <Button onClick={() => navigate(`/vehicle-models/${id}/model-variants/${modelId}/create-variant`)}>
          <span className="bold">{t('add_variant')}</span>
        </Button>}
      </ListHeader>
      <VariantsTableContainer tableHeaders={tableHeaders} data={apiData} noDataMessage={t('no_variants_found')} lessColumns />
      {paginationEle}
    </div>
  );
};

export default VariantsList;
